/*
    $3.6 or 10% of shift if higher than $432
    OT WKND FP
*/

import { DateTime } from "luxon";
import { Shift } from "../../schema";
import { SHIFT_CODES_KEYS } from "../../shiftCodes";
import { FP_OT_WKND_PAY, ShiftData, getMonthDateBoundaries, makeShiftData } from "../common";

export const calculateWeekendPayForShifts = async (allShifts: Shift[], weekendShiftCodeIds: string[]): Promise<ShiftData[]> => {
    const weekendShifts = allShifts.filter((shift) => {
        return weekendShiftCodeIds.includes(shift.shift_code);
    });

    console.log(`[FP Weekend Pay] Found ${weekendShifts.length} weekend shifts`);
    
    // Shifts are calculated individually, if the shift is over $432, then it's 10% of PPV earnings made that shift
    // Otherwise, it's $3.6 per hour
    return weekendShifts.map(shift => {
        let shift_pay: number;
        const hours = shift.end_date_time.diff(shift.start_date_time, "hours").hours;
        
        if (shift.ppv_earned > 432) {
            shift_pay = shift.ppv_earned * 0.1;
            console.log(`[FP Weekend Pay] Shift ${shift.id} earned $${shift.ppv_earned.toFixed(2)}, paying percentage rate: $${shift_pay.toFixed(2)}`);
        } else {
            shift_pay = FP_OT_WKND_PAY * hours;
            console.log(`[FP Weekend Pay] Shift ${shift.id} earned $${shift.ppv_earned.toFixed(2)}, paying hourly rate: $${shift_pay.toFixed(2)}`);
        }
        
        return makeShiftData(shift, shift_pay);
    });
}

export const calculateWeekendDualPayForShifts = async (allShifts: Shift[], weekendDualShiftCodeIds: string[]): Promise<ShiftData[]> => {
    const weekendDualShifts = allShifts.filter((shift) => {
        return weekendDualShiftCodeIds.includes(shift.shift_code);
    });
    
    console.log(`[FP Weekend Dual Pay] Found ${weekendDualShifts.length} weekend dual shifts`);
    
    // Always 10% of PPV earnings, no minimum
    return weekendDualShifts.map(shift => {
        const shift_pay = shift.ppv_earned * 0.1;
        console.log(`[FP Weekend Dual Pay] Shift ${shift.id} earned $${shift.ppv_earned.toFixed(2)}, paying percentage rate: $${shift_pay.toFixed(2)}`);
        
        return makeShiftData(shift, shift_pay);
    });
}

export const weekendPayCalculator = async (shifts: Shift[], month: number, year: number): Promise<ShiftData[]> => {
    console.log(`[FP Weekend Pay] Starting weekend pay calculation for ${month + 1}/${year}`);
    
    const weekendShiftCodes = SHIFT_CODES_KEYS.filter(sc => sc === 'PERM OT WKND FP' || sc === 'TEMP OT WKND FP' || sc === 'OT WKND FP');
    const weekendDualShiftCodes = SHIFT_CODES_KEYS.filter(sc => sc === 'OT WKND DUAL');

    const { start, end } = getMonthDateBoundaries(DateTime.fromObject({ year: year, month: month }, { zone: 'UTC' }));

    const filteredShifts = shifts.filter(shift => 
        shift.start_date_time >= start && 
        shift.start_date_time < end
    );
    console.log(`[FP Weekend Pay] Found ${filteredShifts.length} total shifts for month`);

    const weekendPay = await calculateWeekendPayForShifts(filteredShifts, weekendShiftCodes);
    const weekendDualPay = await calculateWeekendDualPayForShifts(filteredShifts, weekendDualShiftCodes);
    
    return [
        ...weekendPay,
        ...weekendDualPay
    ];
}
